import React from 'react';
import {Modal, Button} from 'react-bootstrap';

let Match = ({children, num}) => (
    <div>{num}. <code>{children}</code></div>
);

let Document = ({docResult}) => {
    let {documentName, warnings} = docResult;

    return (
        <div>
            <h3>In '{documentName}' possible password(s) matching line:</h3>
            {warnings.map(({text, patternMatch}, i) => (
                <Match num={i + 1}>{text ? text : patternMatch.context_line}</Match>
            ))}
        </div>
    );
};

export default class PasswordChecker extends React.Component {
    render() {
        let {data, onIgnore, onClose, isOpen} = this.props;
        let {error, details} = data;
        let {numDocsScanned, numWarnings, docResults} = details;

        return (
            <Modal show={isOpen} onHide={onClose} enforceFocus={false}>
                <Modal.Header>
                    <Modal.Title>{error}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h3>
                        We scanned {numDocsScanned}
                        {numDocsScanned === 1 ? ' document' : ' documents'} and found
                        {' '}{numWarnings} {numWarnings === 1 ? ' error' : ' errors'}
                    </h3>

                    {docResults.map((doc) => (
                        doc.warnings && doc.warnings.length ? <Document docResult={doc}/> : null
                    ))}

                </Modal.Body>
                <Modal.Footer>
                    <span style={{
                        textAlign: 'left',
                        display: 'block',
                        float: 'left',
                        fontSize: '11px'
                    }}>
                        Note: You may use the '*' character(s) to redact passwords
                    </span>
                    <Button bsStyle="warning" onClick={onIgnore}>Ignore and Submit</Button>
                    <Button bsStyle="primary" onClick={onClose}>Back</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./js/app/password_checker/components/passwordChecker.jsx
 **/